import { call, put } from 'redux-saga/effects';
import {
  deleteOrganisationAttachmentFailure,
  fetchOrganisationsRequest,
} from '../actions';
import { deleteOrganisationAttachment } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';

import { checkResponse } from 'store/utils';
import { DeleteOrganisationAttachmentRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* deleteOrganisationAttachmentSaga(
  action: DeleteOrganisationAttachmentRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, attachmentId } = action.payload;
    const deleteResponse: ApiResponse = yield call(
      deleteOrganisationAttachment,
      organisationId,
      attachmentId
    );

    err = checkResponse(deleteResponse?.responseMessage);
    if (err) throw err;
    yield put(fetchOrganisationsRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteOrganisationAttachmentFailure());
  }
}

